// extracted by mini-css-extract-plugin
module.exports = {"v-application":"Checkbox_v-application_1LD5x","text-h1":"Checkbox_text-h1_2QUgi","text-h2":"Checkbox_text-h2_2Nj9M","checkbox":"Checkbox_checkbox_2cJ3q"};